import { createPortal } from 'react-dom';
import React, { useState, Fragment, useContext, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Drawer,
  Divider,
  Snackbar,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import InfoIcon from '../../asset/img/icon_info.svg';
import Error from '../../asset/img/icon_error.svg';
import Close from '../../asset/img/icon_close.svg';
import CheckOn from '../../asset/img/icon_checkbox_on.svg';
import CheckOff from '../../asset/img/icon_checkbox_off.svg';
import ReserveNext from './ReserveNext';
import { postExtV2, postSmileExt, chatai } from '../data/DataLoader';
import AddressSearch from '../address/AddressSearch';
import DataContext from '../data/DataContext';
import { useForm } from 'react-hook-form';
import Terms3 from './Terms3';
import { openLink } from '../util/utilNative';
import Loading from '../page/Loading';
const styles = (theme) => ({
  root: {
    width: '100%',
    position: 'fixed',
    zIndex: '1200',
    inset: '0',
    background: '#fff',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1200',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  divider: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      // cursor: 'pointer',
    },
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0rem',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', // "#da0f47",
    border: '0rem',
    fontWeight: 'bold',
  },
  modalGridItemLabel: {
    padding: '0.75rem 1rem 0rem 1rem',
  },
  modalGridItemLabelFirst: {
    padding: '0.25rem 1rem 0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  modalLabel: {
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
    '& .information': {
      fontSize: theme.font.size14,
      display: 'flex',
      alignItems: 'center',
      border: 'none',
      background: 'none',
    },
  },
  modalField: {
    '& input': {
      borderRadius: '0.375rem',
      width: '100%',
      height: '2.875rem',
      border: 'solid 0.0625rem #929292',
      padding: '0.8125rem 1rem',
    },
  },
  addressSearch: {
    '& button': {
      minHeight: '2.875rem',
      borderRadius: '0.375rem',
      border: 'solid 0.0625rem #000',
      backgroundColor: '#fff',
      width: '100%',
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#000',
    },
  },
  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0rem',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0rem',
  },
  infoIcon: {
    width: '1rem',
    height: '1rem',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '9.375rem',
    borderRadius: '0.375rem',
    background: '#fff',
    font: 'inherit',
    fontSize: '0.875rem',
    padding: '0.8125rem 1rem 2.1875rem',
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  textCount: {
    font: 'inherit',
    fontSize: '0.75rem',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '0.875rem',
    right: '1rem',
  },
  nextLine: {
    paddingTop: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0rem !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '7.5rem',
    border: '0.0625rem solid #929292',
    borderRadius: '0.375rem 0.375rem 0 0',
    fontSize: theme.font.size12,
    padding: '1rem',
    lineHeight: '1.72',
    '& .termsDl': {
      height: '5.45rem',
      overflow: 'auto',
    },
    '& dl': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& dd': {
      marginInlineStart: '0rem',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0rem',
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& ul': {
      paddingInlineStart: '0.625rem',
    },
    '& dt': {
      fontWeight: 'bold',
    },
    '& .layerPopupTop': {
      display: 'none',
    },
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
    '& .termsDl .blind': {
      display: 'none',
    },
  },
  termTextContent: {
    height: '5.5rem',
  },
  checkArea: {
    height: '3rem',
    border: '0.0625rem solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 0.375rem 0.375rem',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    '& input + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOff}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input:checked + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input + label[aria-checked="true"]': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input': {
      height: '1.25rem',
      width: '1.25rem',
      marginRight: '0.375rem !important',
      display: 'none',
    },
  },
  errorIcon: {
    width: '0.75rem',
    height: '0.75rem',
    color: '#ff3723',
    marginRight: '0.1875rem',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0.5rem',
  },
  modelInputLayer: {
    position: 'relative',
  },
  modelSearchLayer: {
    top: '3.125rem',
    left: '0rem',
    right: '0rem',
    position: 'absolute',
    background: '#fff',
    zIndex: '1',
    padding: '0.4063rem 1rem',
    borderRadius: '0.625rem',
    backgroundColor: '#fff',
    maxHeight: '10rem',
    fontSize: theme.font.size14,
    overflowY: 'scroll',
    lineHeight: '2rem',
    boxShadow: '0 0.25rem 0.75rem 0 rgb(0 0 0 / 15%)',
    '& ul': {
      listStyle: 'none',
      margin: '0',
      padding: '0',
    },
    '& li': {
      borderTop: '0.0625rem solid #eee',
      margin: '0',
      padding: '0.8125rem',
      lineHeight: 1.43,
      '&:first-child': {
        border: 'none',
      },
      '&:hover': {
        backgroundColor: '#f9f9f9',
        cursor: 'pointer',
      },
    },
  },
  modelNoData: {
    textAlign: 'center',
    padding: '0.9375rem',
    lineHeight: 1.43,
    fontWeight: 'normal',
  },
  liHighlight: {
    fontWeight: 'bold',
    color: '#ea1917', //"#da0f47",
    textDecoration: 'underline',
  },
  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '40px 20px 15px !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '15px',
    '& button': {
      height: '50px',
      width: '50%',
      borderRadius: '6px',
      border: 'solid 1px #ea1917', //"solid 1px #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', // "#da0f47",
    color: '#fff',
  },
  input: {
    fontSize: theme.font.size14,
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  textareaSentence: {
    fontSize: theme.font.size13,
  },
  modelDesc: {
    color: 'rgb(0 0 0 / 87%)',
    fontSize: '0.8125rem',
  },
  modelDescTxt: {
    position: 'relative',
    paddingLeft: '10px',
    '&::before': {
      content: '"·"',
      display: 'inline-block',
      position: 'absolute',
      left: '0',
      top: '0',
    },
  },
});

const convertModalValue = (orgData, modalValue) => {
  orgData = orgData?.data;
  let newModalValue =
    modalValue &&
    Object.keys(modalValue).reduce((prev, modalId) => {
      if (modalValue[modalId] === null) return prev;

      let targetKey = '';
      switch (modalId) {
        case 'fanLocation':
          targetKey = 'fan_location_data';
          break;
        case 'installType':
          targetKey = 'install_type_data';
          break;
        case 'place':
          targetKey = 'place_type_data';
          break;
      }
      let slotEntity = orgData[targetKey]?.SlotEntity;
      let selectedIndex = modalValue[modalId];
      let entity = orgData[targetKey]?.Items[selectedIndex]?.Entity;
      prev[slotEntity] = entity;
      return prev;
    }, {});
  return newModalValue;
};

const Input = withStyles(styles)((props) => {
  const { classes, register, label, req, errors, readonly } = props;

  return (
    <Fragment>
      <label htmlFor={label} hidden>
        {label}
      </label>
      <input
        id={label}
        {...props}
        {...register(label, req)}
        className={[classes.error, classes.input, readonly ? classes.disabled : ''].join(
          ' '
        )}
        aria-label={errors[label] ? [errors[label].message] : null}
        readOnly={readonly}
      />
      {errors[label] && <ErrorMsg text={[errors[label].message]} />}
    </Fragment>
  );
});

const ErrorMsg = withStyles(styles)((props) => {
  const { classes, text } = props;

  return (
    <Fragment>
      <div className={classes.errorText}>
        <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
        {text}
      </div>
    </Fragment>
  );
});

const ReserveModal = withStyles(styles)((props) => {
  const { classes, modalClose, data, modalCancelReserve } = props;
  const {
    orgData,
    modalValue,
    linkData,
    closeLayer,
    fanLocationInstallType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
    contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  } = data || {
    orgData: null,
    modalValue: null,
    linkData: null,
    closeLayer: false,
    fanLocationInstallType: '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
    contactRating: '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  };

  // console.log('data ::::::::', data);

  const context = useContext(DataContext);
  const [nextModalOpen, setNextModalOpen] = useState(false);
  const [termText, setTermText] = useState('');
  const [loading, setLoading] = useState(false);

  const completeClose = () => {
    setNextModalOpen(false);
    modalClose();
  };

  useEffect(() => {
    closeLayer &&
      closeLayer.getAttribute('data-target') !== 'layer' &&
      setModel((prev) => ({ ...prev, searchLayerShow: false }));
  }, [closeLayer]);

  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermText(term_text);
    })();
  }, []);
  const [possibleDate, setPossibleDate] = useState([]);

  // 출장 예약 요청시 bypass parameter에 필수 키(lockId, detailAddr) 누락 확인 요청 건 24-06
  const [basicInfo, setBasicInfo] = useState({
    user_name: orgData?.data?.user?.user_name || '',
    phone_number: orgData?.data?.user?.phone_number || '',
    address1: orgData?.data?.user?.address1 || '',
    address2: orgData?.data?.user?.address2 || '',
    model: orgData?.data?.model_name || '',
    desc: '',
    zip: orgData.data?.user?.zip || '',
    zipId: '', //hirun
    custNo: '', //hirun
    tel1: '', //hirun
    tel2: '', //hirun
    tel3: '', //hirun
  });

  const newModalValue = convertModalValue(orgData, modalValue);
  const hirunVal =
    orgData.data?.is_hirun ||
    (orgData.data?.is_hirun === false
      ? false //is_hirun이 false로 명시
      : orgData?.data?.need_place_type && modalValue.place == 1
      ? true //is_hirun field가 없고 place_type이 상업공간 (상업용 시스템 에어컨)
      : false); //is_hirun field가 없고 place_type이 상업공간 (가정용 시스템 에어컨)

  //auto-complete
  const [model, setModel] = useState({
    searchVal: orgData.data?.model_name || '',
    // searchValHistory: "",
    // searchResult: [],
    searchResultFiltered: [], //filtered arr
    searchResultOrg: [], //search result arr
    noDataShow: false,
    searchLayerShow: false,
  });
  // const [searchResult, setSearchResult] = useState([])
  const handleModelSearch = async (e) => {
    // e.target.value
    e.preventDefault();
    const svalue = e?.target?.value?.toUpperCase() || '';
    // setSearchVal(svalue)
    // console.log( "handle model search", svalue);
    setModel((pre) => ({ ...pre, searchVal: svalue }));
    setBasicInfo((pre) => ({ ...pre, model: svalue }));

    //검색어의 길이가 3자 이상인 경우
    if (svalue.length >= 3) {
      if (model.searchResultOrg?.length) {
        //기존의 검색 결과가 있는 경우 기존 검색 결과에서 filtering
        console.log('기존 검색 결과가 있는 경우 Filter');
        console.log('FILTER:::', model.searchResultFiltered);
        setModel((prev) => {
          const fltrd = forCss(prev.searchResultOrg, svalue);
          return {
            ...prev,
            searchResultFiltered: fltrd,
            noDataShow: !fltrd.length,
            searchLayerShow: true,
          };
        });
      } else {
        // 기존 검색 결과 없음. 검색한다.
        console.log(' 기존의 검색결과가 없으므로 검색한다.');
        let result = await searchRequest(svalue);
        if (result.result?.sales_model?.length) {
          result.result.sales_model.sort();
          setModel((prev) => ({
            ...prev,
            searchResultFiltered: forCss(result.result.sales_model, svalue),
            searchResultOrg: result.result.sales_model,
            noDataShow: false,
            searchLayerShow: true,
          }));
        } else {
          console.log('검색 결과 없음');
          setModel((prev) => ({
            ...prev,
            searchResultFiltered: [],
            searchResultOrg: [],
            noDataShow: true,
            searchLayerShow: true,
          }));
        }
      }
    } else {
      //검색어가 3자 미만인 경우
      //검색한 결과(gSearchVal,gSearchResult)가 있으면 초기화
      console.log('검색어가 3자 미만. 기존에 검색한 결과result가 있으면 초기화.');
      console.log('options창이 열려 있으면 닫아준다.');
      setModel((prev) => ({
        ...prev,
        searchResultFiltered: [],
        searchResultOrg: [],
        noDataShow: false,
        searchLayerShow: false,
      }));
    }
  };
  const forCss = (result, searchVal) => {
    const filtered = result
      .filter((r) => r.includes(searchVal))
      .map((r) => [
        r,
        r.substr(r.indexOf(searchVal), searchVal.length),
        r.substr(searchVal.length),
      ]);
    return filtered || [];
  };
  const searchRequest = async (svalue) => {
    const client = 'lgcom';
    const category = 'manuals';
    const method = 'get';
    const endpoint = '/manuals/models/search';
    const header = {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-channel': context.channel,
      'x-branch': 'LGEKR',
      'x-country-code': 'kr',
      'x-language-code': 'ko',
      'x-chat-id': 'EngineerRequestWeb',
      'x-session-id': context.client,
    };
    const parameters = {
      search_type: 'base',
      sales_model: svalue,
    };
    const pathParam = {};
    const body = {};
    let result = await chatai(
      client,
      category,
      method,
      endpoint,
      header,
      parameters,
      pathParam,
      body
    );
    console.log('[CHATAI BROKER] praram:', parameters);
    console.log('[CHATAI BROKER] result:', result?.result);
    return result;
  };

  useEffect(() => {
    checkNeedLivechat();
  }, [data]);
  const checkNeedLivechat = () => {
    if (!orgData || !orgData.data) return;

    // const telNum = orgData.data.user?.phone_number
    // var tel1 = telNum&&telNum.substr(0, 3);
    // var tel2 = telNum&&((telNum.length === 10) ? telNum.substr(3, 3) : telNum.substr(3, 4));
    // var tel3 = telNum&&telNum.substr(telNum.length-4, 4);
    if (
      //엔지니어출장인경우
      (orgData?.type === 'engineer' &&
        orgData.data.need_fan_location &&
        orgData.data.need_livechat &&
        orgData.data.livechat_data &&
        orgData.data.livechat_data.Items &&
        orgData.data?.livechat_data?.Items?.includes(
          orgData?.data?.fan_location_data?.Items?.[modalValue.fanLocation]?.Entity
        )) || //세척서비스 일경우
      // orgData.data.svc_type==="D"
      (orgData?.type === 'cleaning' &&
        orgData.data.need_livechat &&
        modalValue.place === 1)
    ) {
      const defaultParameters = linkData?.parameters;
      const defaultExpect = linkData?.expect;
      const productCode = context.isSFDC
        ? orgData.data.need_place_type
          ? modalValue.place === 0
            ? 'RECRB'
            : 'COCRA'
          : orgData.data?.sfdc_product_code
        : orgData.data?.gscs_product_code;
      const productName = context.isSFDC
        ? orgData.data.sfdc_product_name
        : orgData.data.gscs_product_name;

      context.request(
        context,
        defaultParameters?.speech || '',
        'button',
        {
          ...defaultParameters,
          bypass_br: 'livechat',
          request_type: orgData.data.request_type,
          is_hirun: hirunVal,
          rcptType: orgData.data.svc_type,
          user_name: orgData.data.user?.user_name,
          phone_number: orgData.data?.user?.phone_number,
          zipNo: orgData.data.user?.zip,
          detailAddr: orgData.data.user?.address2,
          svcType: orgData.data.svc_type, //A:출장접수,B:내방예약,D:가전세척
          rcptUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3',
          productCode: productCode,
          productName: productName,
          rcptSympCode: orgData.data.rcptSympCode,
          rcptSubSympCode: orgData.data.rcptSubSympCode,
          rcptFurtherSubSympCode: orgData.data.rcptFurtherSubSympCode,
          comment: '', //사용자 입력 고장 증상, 챗봇 전달 사항
          place_type: modalValue.place,
          fan_location: modalValue.fanLocationb,
          install_type: modalValue.installType,
          // "custType": "A", //custType=A (일반고객)
          rcptDeptType: '', //접수처구분 D(인터넷) /E(스마트폰)/?
          // "personInfoAgreeFlag": "Y", //고객정보동의활용여부
          deptCode: '', //센터 방문예약시 필수
          modelCode: '', //모델코드
        },
        defaultExpect || {
          mode: 'bypass',
          intent: 'THQ_ENGINEER_BOOK_BYPASS',
        }
      );
      modalClose();
    }
    // else{

    // }
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    clearErrors,
    setFocus,
  } = useForm();

  const onSubmit = async (data) => {
    console.log('[orgData]', orgData);
    console.log('[modalValue]', modalValue);
    console.log('[basicInfo]', basicInfo);

    // const zipId = hirunVal? await retrieveAddrRefineSmile() : await retrieveAddrRefine();
    let zipId = '';
    if (context.isSFDC) {
      zipId = await retrieveAddrRefine();
    } else {
      zipId = await retrieveAddrRefineSmile();
    }

    if (zipId && zipId.length > 0) {
      if (context.isSFDC) {
        hirunVal
          ? retrieveSeVisitPossibleDateSmile(zipId)
          : retrieveSeVisitPossibleDate(zipId);
      } else {
        retrieveSeVisitPossibleDateSmile(zipId);
      }
      setLoading(true);
    } else {
      setError('address3', { type: 'custom', message: 'custom message' });
    }
  };

  const termsRef = useRef();
  const onError = async (errors, e) => {
    console.log('on error!! errors: ', errors);
    console.log('on error!! e: ', e);

    // const address1 = document.querySelector('input[name="address1"]');
    // setTimeout(() => {
    //   address1.blur();
    // }, 1);

    if (errors.user_name) {
      setTimeout(() => {
        setFocus(e.target[0].name);
      }, 300);
    } else if (errors.phone_number) {
      setTimeout(() => {
        setFocus(e.target[1].name);
      }, 300);
    } else if (errors.phone_number2) {
      setTimeout(() => {
        setFocus(e.target[2].name);
      }, 300);
    } else if (errors.address1) {
      setTimeout(() => {
        setFocus(e.target[3].name);
      }, 300);
    } else if (errors.address2) {
      setTimeout(() => {
        setFocus(e.target[5].name);
      }, 300);
    } else if (errors.terms) {
      setTimeout(() => {
        termsRef.current.focus();
      }, 300);
    }

    if (errors.address3) {
      let zipId = '';
      if (context.isSFDC) {
        zipId = hirunVal ? await retrieveAddrRefineSmile() : await retrieveAddrRefine();
      } else {
        zipId = await retrieveAddrRefineSmile();
      }
      if (zipId.length > 0) {
        clearErrors('address3');
        // retrieveSeVisitPossibleDateSmile(zipId);
        if (context.isSFDC) {
          hirunVal
            ? retrieveSeVisitPossibleDateSmile(zipId)
            : retrieveSeVisitPossibleDate(zipId);
        } else {
          retrieveSeVisitPossibleDateSmile(zipId);
        }
        setLoading(true);
      }
    }
  };
  async function retrieveSeVisitPossibleDate(zipId) {
    try {
      const telNum = basicInfo.phone_number;
      var tel1 = telNum && telNum.substr(0, 3);
      var tel2 =
        telNum && (telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4));
      var tel3 = telNum && telNum.substr(telNum.length - 4, 4);
      setBasicInfo((prev) => ({ ...prev, tel1: tel1, tel2: tel2, tel3: tel3 }));

      const client = 'lgcom';
      const header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-channel': client,
        'x-branch': 'LGEKR',
        'x-country-code': 'kr',
      };
      const body = {
        zipNo: basicInfo.zip,
        productCode: orgData.data.need_place_type
          ? modalValue.place === 0
            ? 'RECRB'
            : 'COCRA'
          : orgData.data?.sfdc_product_code,
        svcType: orgData.data.svc_type, //A:출장접수,B:내방예약,D:가전세척,
        zipId: zipId,
        custName: basicInfo.user_name, // string	고객이름 	선택	시그니처 T/T
        telNo1_1: tel1, //basicInfo.tel1,
        telNo1_2: tel2, //basicInfo.tel2,
        telNo1_3: tel3, //basicInfo.tel3,
        rcptSympCode: orgData.data.rcptSympCode, // string	증상코드 (1depth)	선택
        rcptSubSympCode: orgData.data.rcptSubSympCode, // string	증상분류코드 (2depth)	선택	가전세척 불필요
        rcptFurtherSubSympCode: orgData.data.rcptFurtherSubSympCode, // string	상세 증상코드 (3depth)	선택	가전세척 불필요
        rcptUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3', // string	접수자ID (WWW3, WWW4, WWW7, WWW13)	필수 | WWW3 PC 접근 (LGE.COM), WWW4 모바일 접근 (LGE.COM)
        modelCode: basicInfo.model || '', // string	판매 모델 	선택	모델코드
        installType: fanLocationInstallType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        contactRating: contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      };
      let result = await postExtV2(
        client,
        'sfdc',
        'post',
        '/sfdc/visits/retrieveSeVisitPossibleDate',
        header,
        body
      );
      console.log('::[날짜 검색 결과][postExtV2] praram::', body);
      console.log('[postExtV2] result:', result);
      result.result && setPossibleDate(result.result);
      // T/T없을 시, 안내문구 수정 24-05 (테스트)
      // result.result && setPossibleDate([]);

      setNextModalOpen(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setPossibleDate([]);
      setNextModalOpen(true);
      setLoading(false);
    }
  }

  async function retrieveAddrRefine() {
    let zipId = '';
    try {
      const client = 'lgcom';
      const header = {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-channel': client,
        'x-branch': 'LGEKR',
        'x-country-code': 'kr',
      };
      const body = {
        searchText: basicInfo.address1 + ' ' + basicInfo.address2,
      };
      let result = await postExtV2(
        client,
        'sfdc',
        'post',
        '/sfdc/visits/retrieveAddrRefine',
        header,
        body
      );
      console.log('[postExtV2] praram:', body);
      console.log('[postExtV2] result:', result);
      zipId = result.result?.ZIPID;
      const telNum = basicInfo.phone_number;
      var tel1 = telNum && telNum.substr(0, 3);
      var tel2 =
        telNum && (telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4));
      var tel3 = telNum && telNum.substr(telNum.length - 4, 4);
      var custNo = result.result?.custNo || '';
      setBasicInfo((prev) => ({
        ...prev,
        zipId: zipId,
        custNo: custNo,
        tel1: tel1,
        tel2: tel2,
        tel3: tel3,
      }));
    } catch (error) {
      console.log(error);
    }
    //return {zipId, custNo, tel1, tel2, tel3}
    return zipId;
  }

  async function retrieveAddrRefineSmile() {
    let zipId = '';
    try {
      const body = {
        searchText: basicInfo.address1 + ' ' + basicInfo.address2,
      };
      let result = await postSmileExt(context, 'retrieve/retrieveAddrRefine', body);
      console.log('[postSmileExt] praram:', body);
      console.log('[postSmileExt] result:', result);

      if (result.result?.ZIPID) {
        zipId = result.result?.ZIPID;
        setBasicInfo((prev) => ({ ...prev, zipId: zipId }));
        // }else{
        //   return false
      }
    } catch (error) {
      console.log(error);
      setBasicInfo((prev) => ({ ...prev, zipId: '' }));
      // return false
    }
    return zipId;
  }

  async function retrieveSeVisitPossibleDateSmile(zipId) {
    // const {zipId, tel1, tel2, t  el3} = await retrieveAddrRefineSmile()
    console.log('[retrieveSeVisitPossibleDateSmile]>>>>>>>>>>>>>>>>>>', basicInfo);

    try {
      const telNum = basicInfo.phone_number;
      var tel1 = telNum && telNum.substr(0, 3);
      var tel2 =
        telNum && (telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4));
      var tel3 = telNum && telNum.substr(telNum.length - 4, 4);
      setBasicInfo((prev) => ({ ...prev, tel1: tel1, tel2: tel2, tel3: tel3 }));
      let productCode = '';
      if (context.isSFDC) {
        productCode = orgData.data.need_place_type
          ? modalValue.place === 0
            ? 'RECRB'
            : 'COCRA'
          : orgData.data?.sfdc_product_code;
      } else {
        productCode = orgData.data.need_place_type
          ? modalValue.place === 0
            ? 'CRB'
            : 'CRA'
          : orgData.data?.gscs_product_code;
      }
      const body = {
        // "svcType": orgData.data.svc_type,  //A:출장접수,B:내방예약,D:가전세척
        zipId: zipId,
        productCode: productCode,
        // "productCode": orgData.data?.gscs_product_code,
        primiumYn: orgData.data?.premium,
        custName: basicInfo.user_name,
        telNo1_1: tel1,
        telNo1_2: tel2,
        telNo1_3: tel3,
        signatureSmYn: 'Y',
        rcptSympCode: orgData.data?.rcptSympCode,
        rcptSubSympCode: orgData.data?.rcptSubSympCode,
        purpose: modalValue.place === 1 ? 'C' : 'H', //H: 주거 C: 상업,
        is_hirun: hirunVal ? 'yes' : undefined,
        // installType: fanLocationInstallType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
        // contactRating: contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-06
      };
      let result = await postSmileExt(
        context,
        'retrieve/retrieveSeVisitPossibleDate',
        body
      );
      console.log('[postSmileExt] praram:', body);
      console.log('[postSmileExt] result:', result);
      setPossibleDate(result.result.possibleDate);
      setNextModalOpen(true);
      setLoading(false);
    } catch (error) {
      console.log('[retrieveSeVisitPossibleDateSmile]', error);
      setPossibleDate([]);
      setNextModalOpen(true);
      setLoading(false);
    }
  }

  const [textCount, setTextCount] = useState(0);
  const handleChange = (event) => {
    // console.log('handlechange ::::::::::::::::', event.target.value);
    // console.log('handlechange ::::::::::::::::', event.target.name);

    const name = event.target.name;
    const value = event.target.value;
    setBasicInfo((prev) => ({ ...prev, [name]: value }));

    name === 'desc' && setTextCount(value.length);
    // name==="address1" && (setBasicInfo(prev=>({...prev, address2:""})))
    // console.log("변경::", name, value)
  };
  const modelItemClick = (e) => {
    const model_name = e.target.getAttribute('data-model');
    setBasicInfo((prev) => ({ ...prev, model: model_name }));
    setModel((prev) => ({ ...prev, searchVal: model_name, searchLayerShow: false }));
  };
  const [termModalOpen, setTermModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const onClickCheckbox = () => {
    setChecked((prev) => !prev);
  };
  const activeEnter = (e) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      onClickCheckbox();
    }
  };

  const dispatch = () => {
    var input = document.querySelector('input[name="address1"]');
    const event = new Event('input', { bubbles: true });
    const tracker = input._valueTracker;
    if (tracker) {
      tracker.setValue('');
    }
    input.dispatchEvent(event);
  };
  const handleClickModelLink = () => {
    const url = 'https://www.lge.co.kr/mkt/product/productPhotoGuide?chatbot=y';
    openLink(context, 'external', url);
  };

  const phoneValidator = (telNum) => {
    var ment = '';
    var tel1 = '';
    var tel2 = '';
    var tel3 = '';
    var tel2_ = '';
    var result = '휴대전화 번호를 정확히 입력해 주세요';

    try {
      tel1 = telNum.substr(0, 3);
      tel2 = telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4);
      tel3 = telNum.substr(telNum.length - 4, 4);
      tel2_ = telNum.substr(3, 1);

      if (
        (tel1 === '011' ||
          tel1 === '016' ||
          tel1 === '017' ||
          tel1 === '018' ||
          tel1 === '019') &&
        tel2.length === 3
      ) {
        if (tel2 >= 200 && tel2 <= 899) {
          //return true;
        } else {
          ment =
            '국번 번호는 "200~899" 만 허용하며, "000~199", "900~999" 허용 불가합니다.';
        }
      }
      if (ment === '') {
        switch (tel1) {
          case '010':
            if (tel2_ === '0' || tel2_ === '1') {
              ment = '국번 번호의 첫자리가 "0, 1"은 잘못된 국번입니다.';
            } else {
              /*return true;*/
            }
            break;
          case '011':
            if (tel2.length === 4) {
              if ((tel2 >= 1700 && tel2 <= 1799) || (tel2 >= 9500 && tel2 <= 9999)) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "1700~1799" 또는 "9500~9999" 만 허용합니다.';
              }
            } else if (tel2.length === 3) {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "200~899" 만 허용합니다.';
              }
            }
            break;
          case '016':
          case '019':
            if ((tel2 >= 200 && tel2 <= 899) || (tel2 >= 9000 && tel2 <= 9999)) {
              //return true;
            } else {
              ment =
                '국번 번호 범위가 맞지 않습니다. "016, 019" 이면 "9000~9999" 까지만 허용합니다.';
            }
            break;
          case '017':
          case '018':
            if (tel2.length === 4) {
              ment = '"017, 018"의 경우 국번은 4자리이면 안됩니다.';
            } else {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "017, 018" 이면 "200~899" 까지만 허용합니다.';
              }
            }
            break;
          default:
            ment = '"010, 011, 016, 017, 018, 019" 만 허용합니다.';
            break;
        }
      }
      return ment === '' || result;
    } catch (er) {
      return result;
    } finally {
      console.log(
        '휴대폰번호 유효성 검사결과 : [tel1:' +
          tel1 +
          ', tel2:' +
          tel2 +
          ', tel3:' +
          tel3 +
          ', tel2_:' +
          tel2_ +
          ']' +
          ment
      );
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <Grid container className={classes.modalGridContainer}>
          {/* 이름 */}
          <Grid
            item
            xs={12}
            className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
              ' '
            )}
          >
            <div className={classes.modalLabel}>
              이름<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="user_name"
                register={register}
                errors={errors}
                req={{
                  required: '이름을 입력해주세요.',
                  minLength: { value: 1, message: '이름을 입력해주세요.' },
                  maxLength: { value: 25, message: '최대 입력 길이를 초과하였습니다.' },
                  pattern: {
                    value: /^[ㄱ-ㅎ가-힣a-zA-Z|]+$/gi,
                    message: '이름은 한글, 영문만 가능합니다.',
                  },
                  disabled: orgData?.data?.user?.user_name ? true : false,
                  onChange: handleChange,
                }}
                value={basicInfo.user_name || ''}
                disabled={orgData?.data?.user?.user_name ? true : false}
                placeholder="이름을 입력해 주세요."
                type="text"
                maxLength="25"
                title="이름"
              />
            </div>
          </Grid>
          {/* 휴대전화번호 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              휴대전화번호<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="phone_number"
                register={register}
                errors={errors}
                req={{
                  required: '휴대전화 번호를 입력해 주세요.',
                  minLength: {
                    value: 10,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  maxLength: {
                    value: 11,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  // pattern: {value:/^[0-9]*$/gi, message:'숫자만 입력 가능합니다.'},
                  pattern: {
                    value: /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/gi,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  validate: { phoneValidator },
                  disabled: orgData?.data?.user?.phone_number ? true : false,
                  onChange: handleChange,
                }}
                value={basicInfo.phone_number || ''}
                disabled={orgData?.data?.user?.phone_number ? true : false}
                placeholder="'-'를 제외한 휴대전화 번호를 입력해 주세요."
                type="tel"
                maxLength="11"
                title="휴대전화번호"
              />
            </div>
          </Grid>
          {/* 휴대전화번호 재확인*/}
          {!orgData?.data?.user?.user_name && (
            <Fragment>
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={classes.modalLabel}>
                  휴대전화번호 재확인<span className="star">*</span>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.modalGridItem}>
                <div className={classes.modalField}>
                  <Input
                    label="phone_number2"
                    register={register}
                    errors={errors}
                    req={{
                      validate: (value) =>
                        value === basicInfo.phone_number ||
                        '휴대전화 번호가 일치하지 않아요.',
                    }}
                    placeholder="휴대전화 번호를 다시 입력해 주세요."
                    type="tel"
                    maxLength="11"
                    title="휴대전화번호 재확인"
                  />
                </div>
              </Grid>
            </Fragment>
          )}
          {/* 주소 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              주소<span className="star">*</span>
            </div>
          </Grid>
          <Grid container className={classes.modalGridItem}>
            <Grid item xs={9} className={classes.modalInnerItem}>
              <div className={classes.modalField}>
                <Input
                  placeholder="주소찾기 버튼을 눌러주세요."
                  // className={[classes.disabled, classes.input].join(' ')}
                  name="address1"
                  label="address1"
                  value={basicInfo.address1 || ''}
                  register={register}
                  errors={errors}
                  req={{
                    required: '주소찾기 버튼을 눌러주세요.',
                  }}
                  readonly={true}
                  title="주소"
                />
              </div>
            </Grid>
            <Grid
              item
              xs={3}
              className={[classes.modalInnerItem, classes.modalInnerItemLast].join(' ')}
            >
              <div className={[classes.modalField, classes.addressSearch].join(' ')}>
                <AddressSearch setBasicInfo={setBasicInfo} dispatch={dispatch} />
              </div>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className={[classes.modalGridItem, classes.nextLine].join(' ')}
          >
            <div className={classes.modalField}>
              <Input
                label="address2"
                register={register}
                errors={errors}
                req={{
                  required: '상세 주소를 입력해 주세요.',
                  maxLength: { value: 150, message: '최대 입력길이를 초과하였습니다.' },
                  validate: (value) => {
                    return !!value.trim() || '상세 주소를 입력해 주세요.';
                  },
                  onChange: handleChange,
                }}
                value={basicInfo.address2 || ''}
                placeholder="상세 주소를 입력해 주세요."
                title="상세 주소"
              />
              {!errors.address2 && errors.address3 && (
                <ErrorMsg
                  text={
                    '일시적인 오류로 주소를 인식하지 못했습니다. 주소를 다시 입력해 주세요.'
                  }
                />
              )}
            </div>
          </Grid>
          {/* 모델명 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              모델명
              <button
                className="information"
                onClick={handleClickModelLink}
                title="새창열림"
              >
                <img src={InfoIcon} className={classes.infoIcon} alt="도움말" />
              </button>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div
              className={[classes.modalField, classes.modelInputLayer].join(' ')}
              data-target="layer"
            >
              <label for="model" hidden>
                모델명
              </label>
              <input
                id="model"
                className={classes.input}
                type="text"
                placeholder="제품 모델명 코드를 입력하세요."
                name="model"
                onChange={handleModelSearch}
                onClick={handleModelSearch}
                value={model.searchVal}
                data-target="layer"
                title="모델명"
              />
              <div className={classes.modelDesc}>
                <p className={classes.modelDescTxt}>
                  모델명, 제품 번호를 입력하시면, 더 정확하게 서비스 준비를 할 수 있어요.
                </p>
              </div>
              {model.searchLayerShow && (
                <div className={classes.modelSearchLayer} data-target="layer">
                  <ul data-target="layer">
                    {model.searchResultFiltered.map((r, index) => (
                      <li
                        key={`model-search-${index}`}
                        data-target="layer"
                        data-model={r[0]}
                        onClick={modelItemClick}
                      >
                        <span className={classes.liHighlight} data-model={r[0]}>
                          {r[1]}
                        </span>
                        {r[2]}
                      </li>
                    ))}
                  </ul>
                  {model.noDataShow && (
                    <div className={[classes.modelNoData].join(' ')}>
                      입력하신 키워드와 일치하는 <br />
                      모델명이 없습니다.
                    </div>
                  )}
                </div>
              )}
            </div>
          </Grid>
          {/* 전달사항 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>전달사항(선택)</div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={[classes.modalField, classes.textareaField].join(' ')}>
              <label for="desc" hidden>
                전달사항(선택)
              </label>
              <textarea
                id="desc"
                className={classes.textarea}
                placeholder="서비스 매니저에게 전달할 내용이 있다면 입력해 주세요. 개인정보 보호를 위해 주민등록번호, 휴대폰 번호 등 민감정보는 입력하지 않도록 유의해 주세요."
                name="desc"
                onChange={handleChange}
                value={basicInfo.desc || ''}
                maxLength={100}
                title="전달사항(선택)"
              />
              <span className={classes.textCount}>{textCount}/100자</span>
            </div>
            <div className={classes.textareaSentence}>
              {data.orgData?.type === 'cleaning' ? (
                <div>
                  · 전달사항 입력란에 개인정보 보호를 위해 주민등록번호, 휴대폰 번호 등
                  민감정보는 입력하지 않도록 유의해 주세요.
                  <br />
                  · 입력하신 정보가 정확하지 않을 경우 서비스가 취소 또는 지연될 수
                  있습니다.
                  <br />· 도서(섬) 지역의 경우 관계법령에 따라 일부 서비스가 제한될 수
                  있습니다.
                  <br />· 제품 설치 형태/환경 및 노후 정도에 따라 가전세척 서비스 제공이
                  어려울 수 있습니다.
                  <br />· 2대 이상의 제품을 한 번에 신청하신 경우, 당일 동시 서비스 제공이
                  어려울 수 있습니다
                </div>
              ) : (
                <div>
                  · 전달사항 입력란에 개인정보 보호를 위해 주민등록번호, 휴대폰 번호 등
                  민감정보는 입력하지 않도록 유의해 주세요.
                  <br />
                  · 입력하신 정보가 정확하지 않을 경우 서비스가 취소 또는 지연될 수
                  있습니다.
                  <br />· 도서(섬) 지역의 경우 관계법령에 따라 일부 서비스(용접 수리, 냉매
                  보충 등)가 제한될 수 있습니다.
                </div>
              )}
            </div>
          </Grid>
        </Grid>

        {/* 개인정보 수집 및 이용동의 */}
        {!(
          orgData &&
          orgData.data &&
          orgData.data.user &&
          orgData.data.user.user_name
        ) && (
          <Fragment>
            <Grid item xs={12} className={classes.modalGridItemLabel}>
              <div className={[classes.modalLabel, classes.terms].join(' ')}>
                <div>
                  개인정보 수집 및 이용동의<span className="star">*</span>
                </div>
                <button
                  className={classes.showAll}
                  onClick={() => {
                    setTermModalOpen(true);

                    const rootChild = document.getElementById('modal');
                    const focusableElements = rootChild.querySelectorAll('*');

                    for (let i = 0; i < focusableElements.length; i++) {
                      focusableElements[i].setAttribute('aria-hidden', 'true');
                    }
                  }}
                >
                  전문보기
                </button>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalGridItem}>
              <div className={[classes.modalField, classes.textareaField].join(' ')}>
                <div className={classes.termTextArea}>
                  <div
                    className={classes.termTextContent}
                    dangerouslySetInnerHTML={{ __html: termText }}
                  />
                </div>
                <input
                  type="hidden"
                  value={checked}
                  {...register('terms', { validate: (val) => checked })}
                />
                <div className={classes.checkArea}>
                  <input
                    id="term_check"
                    type="checkbox"
                    checked={checked}
                    onClick={() => {
                      setChecked((prev) => !prev);
                    }}
                  />
                  <label
                    for="term_check"
                    role="checkbox"
                    aria-checked={checked}
                    tabIndex="0"
                    onKeyDown={(e) => activeEnter(e)}
                    aria-label={
                      errors.terms
                        ? '먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.'
                        : null
                    }
                    name="terms"
                    ref={termsRef}
                  >
                    {' '}
                    동의합니다.
                  </label>
                </div>
              </div>
              {errors.terms && (
                <div className={classes.errorText}>
                  <img src={Error} className={classes.errorIcon} alt="체크 필요" />
                  먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
                </div>
              )}
            </Grid>
          </Fragment>
        )}
        {/* footer button */}
        <Grid container className={classes.modalFooter}>
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button
              type="button"
              className={classes.modalButton}
              onClick={modalCancelReserve}
            >
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={classes.modalButtonRight}>
            <button
              type="submit"
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
            >
              확인
            </button>
          </Grid>
        </Grid>
      </form>
      <ReserveNext
        modalOpen={nextModalOpen}
        modalClose={() => setNextModalOpen(false)}
        possibleDate={possibleDate}
        data={data}
        basicInfo={basicInfo}
        completeClose={completeClose}
        hirunVal={hirunVal}
      />
      <Terms3
        modalOpen={termModalOpen}
        modalClose={() => {
          setTermModalOpen(false);
          const rootChild = document.getElementById('modal');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].removeAttribute('aria-hidden');
          }
        }}
        checkOk={(ok) => {
          setChecked(ok);
        }}
      />
      <div className={[classes.loading, !loading && classes.loadComplete].join(' ')}>
        <Loading />
      </div>
    </Fragment>
  );
});

function Reserve(props) {
  const { classes, data, modalOpen, modalClose } = props;
  const context = useContext(DataContext);
  const { linkData } = data || { orgData: null, modalValue: null, linkData: null };
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const modalCancelReserve = () => {
    setCloseDialogOpen(true);
  };
  const close = () => {
    const defaultParameters = linkData?.parameters;
    const defaultExpect = linkData?.expect;
    context.request(
      context,
      defaultParameters?.speech || '그만하기',
      'button',
      {
        ...defaultParameters,
        bypass_br: 'cancel',
      },
      defaultExpect || {
        mode: 'bypass',
        intent: 'THQ_ENGINEER_BOOK_BYPASS',
      }
    );

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }

    modalClose();
  };
  const handleClick = (e) => {
    setCloseLayer(e.target);
  };
  const [closeLayer, setCloseLayer] = useState(null);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);

  return createPortal(
    <div className={classes.root} onClick={handleClick}>
      {modalOpen && (
        <div className={classes.drawerFrame}>
          {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={modalCancelReserve}
        classes={{ paper: classes.drawerFrame }}
      > */}

          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div
                  className={[classes.titleClose].join(' ')}
                  ref={modalRef}
                  tabIndex="0"
                >
                  {' '}
                  {data.orgData?.type === 'cleaning'
                    ? '가전 세척 예약하기'
                    : '출장서비스 예약'}{' '}
                </div>
                <button className={classes.close} onClick={modalCancelReserve}>
                  <img src={Close} className={classes.arrowDown} alt="닫기" />
                </button>
              </div>
              <Divider classes={{ root: classes.divider }} />
            </div>
            <div className={classes.componentWrapper}>
              {/* <Component data={data} parentFunc={parentFunc} modalClose={modalClose} parentVal={parentVal} customClose={customClose}/> */}
              <ReserveModal
                data={{ ...data, closeLayer: closeLayer }}
                modalCancelReserve={modalCancelReserve}
                modalClose={modalClose}
              />
            </div>
          </div>
        </div>
      )}
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button className={classes.dialogFooterBtnLeft} onClick={() => close(false)}>
            그만하기
          </button>
          <button
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(Reserve);
